import actions from '@/core/store/pedido/revisoes/actions'

export default {
	actions,
}
